import { render } from "./AdminSubscriptionEdit.vue?vue&type=template&id=b2604122&scoped=true&ts=true"
import script from "./AdminSubscriptionEdit.vue?vue&type=script&lang=ts"
export * from "./AdminSubscriptionEdit.vue?vue&type=script&lang=ts"

import "./AdminSubscriptionEdit.vue?vue&type=style&index=0&id=b2604122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2604122"]])

export default __exports__